import type { FC } from "react";

import { useViewportInfoContext } from "@/src/contexts";
import type { ILink } from "@Components/Link";
import { Link } from "@Components/Link";

import type { ILogoTile } from "../common/LogoTile";
import LogoTile from "../common/LogoTile";

import * as css from "./ShoppingMallHeader.module.css";

export enum Tabs {
    Offers,
    Brands,
    Details,
    SavedDiscounts,
}

export interface IShoppingMallHeader {
    logo: ILogoTile;
    name: string;
    tabs: ILink[];
    selectedTab?: number;
    onTabChange?: (index: Tabs) => void;
    openHours?: string;
}

export const ShoppingMallHeader: FC<IShoppingMallHeader> = (props) => {
    const { isMobile, isMobileOrTablet } = useViewportInfoContext();
    const changeTab = (index: number) => {
        if (props.onTabChange) {
            props.onTabChange(index);
        }
    };

    const renderTabs = () => {
        if (!props.tabs) {
            return null;
        }

        const getTabClassName = (index: number): string => {
            let className: string = "";

            if (props.selectedTab === index) {
                className = `${css.selected}`;
            }

            return className;
        };

        return (
            <ul className={css.tabsContainer}>
                {props.tabs.map((tab: ILink, i: number) => {
                    if (isMobileOrTablet && i === Tabs.SavedDiscounts) {
                        return null;
                    }

                    const onTabClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
                        changeTab(i);
                        event.preventDefault();
                        return true;
                    };
                    return (
                        <li key={i} className={`${css.tabsContainerItem} ${getTabClassName(i)}`}>
                            <h2>
                                <Link {...tab} onClick={onTabClick} hideLoading={true} />
                            </h2>
                        </li>
                    );
                })}
            </ul>
        );
    };

    return (
        <div className={css.shoppingMallHeaderComponent}>
            <div className={css.header}>
                <div className={css.logoItemButton}>
                    <LogoTile {...props.logo} type="malls" />
                </div>
                <div className={css.details}>
                    <h1>{props.name}</h1>
                    <div className={css.openHours}>
                        <Link
                            text={props.openHours}
                            appearance={1}
                            onClick={() => changeTab(Tabs.Details)}
                            navigateUrl={props.tabs ? props.tabs[Tabs.Details].navigateUrl : undefined}
                        />
                    </div>
                    {!isMobile && renderTabs()}
                </div>
            </div>
            {isMobile && renderTabs()}
        </div>
    );
};
